import "./modal.scss";

export default function Modal({
  close,
  children,
  size,
  className,
  title,
  footer,
  noBodyPadding,
  stickyFooter,
}) {
  return (
    <>
      <div className="modal-backdrop">
        <div
          className={
            "modal full-mobile " +
            size +
            (stickyFooter ? " sticky-footer " : "")
          }
        >
          <span
            className="close-btn material-symbols-outlined"
            onClick={() => {
              close();
            }}
          >
            close
          </span>

          <div className={"modal-container " + (className ? className : "")}>
            {title && <div className="modal-header">{title}</div>}

            {children &&
              (noBodyPadding ? (
                children
              ) : (
                <div className="modal-body">{children}</div>
              ))}

            {footer && <div className="modal-footer">{footer}</div>}
          </div>
        </div>
      </div>
    </>
  );
}
